import { render, staticRenderFns } from "./SelfPlayer.vue?vue&type=template&id=f5bca636"
import script from "./SelfPlayer.vue?vue&type=script&lang=js"
export * from "./SelfPlayer.vue?vue&type=script&lang=js"
import style0 from "./SelfPlayer.vue?vue&type=style&index=0&id=f5bca636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports